"use client"
import { BlockRenderer, CustomBreadcrumbs, TopBanner } from "ui"
import { getBreadCrumbs } from "utils"
import { findProperty } from "utils/findProperty"
import NoticeInvestorsTab from "./NoticeInvestorsTab"

type Props = {
  data: any
  locale: string
  messages: {
    view: string
    additional: string
  }
}
function NoticesToInvestors({ data, messages, locale }: Props) {
  const { selfObject, parents } = getBreadCrumbs(data, locale)
  const components = {
    topBanner: TopBanner,
    immediateReportsTabMain: NoticeInvestorsTab,
  }
  const blocks = findProperty(data.page, "blocks")?.blocks || []
  const hasBanner = blocks?.some(
    (block: any) => block.blockType === "topBanner" || block.blockType === "HeaderWithHeroAndText",
  )
  return (
    <>
      {blocks?.map((block: any, index: number) => {
        let additionalProps = {}
        if (block.blockType === "contentText") {
          additionalProps = {
            hasBanner: hasBanner,
            messages,
          }
        } else {
          additionalProps = { messages }
        }
        return (
          <BlockRenderer
            key={index}
            blockType={block.blockType}
            blockData={block}
            props={additionalProps}
            components={components}
          >
            {block.blockType === "immediateReportsTabMain" && (
              <CustomBreadcrumbs current={selfObject} parents={parents} />
            )}
          </BlockRenderer>
        )
      })}
    </>
  )
}

export default NoticesToInvestors
